import { render } from "./df-count-up.vue?vue&type=template&id=98dd7230"
import script from "./df-count-up.vue?vue&type=script&lang=js"
export * from "./df-count-up.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__